export const levelButtons = [
    {
        "id": 0,
        "position": {
            "x": 41.25,
            "y": 35.999997456868485
        },
        "closest": [
            1
        ]
    },
    {
        "id": 1,
        "position": {
            "x": 100,
            "y": 119.33333079020183
        },
        "closest": [
            2,
            0
        ]
    },
    {
        "id": 2,
        "position": {
            "x": 161.25,
            "y": 192.66666412353516
        },
        "closest": [
            3,
            4,
            1
        ]
    },
    {
        "id": 3,
        "position": {
            "x": 225,
            "y": 292.66666412353516
        },
        "closest": [
            11,
            2
        ]
    },
    {
        "id": 4,
        "position": {
            "x": 257.5,
            "y": 105.99999745686848
        },
        "closest": [
            7,
            2
        ]
    },
    {
        "id": 5,
        "position": {
            "x": 172.5,
            "y": 480.9999974568685
        },
        "closest": [
            6,
            11
        ]
    },
    {
        "id": 6,
        "position": {
            "x": 55,
            "y": 570.9999974568684
        },
        "closest": [
            12,
            5
        ]
    },
    {
        "id": 7,
        "position": {
            "x": 375.625,
            "y": 28.49999745686849
        },
        "closest": [
            8,
            4
        ]
    },
    {
        "id": 8,
        "position": {
            "x": 438.125,
            "y": 108.49999745686848
        },
        "closest": [
            9,
            7
        ]
    },
    {
        "id": 9,
        "position": {
            "x": 521.25,
            "y": 224.3333307902018
        },
        "closest": [
            18,
            17,
            10,
            8
        ]
    },
    {
        "id": 10,
        "position": {
            "x": 415,
            "y": 312.66666412353516
        },
        "closest": [
            9,
            11
        ]
    },
    {
        "id": 11,
        "position": {
            "x": 297.5,
            "y": 402.66666412353516
        },
        "closest": [
            5,
            16,
            10,
            3
        ]
    },
    {
        "id": 12,
        "position": {
            "x": 113.125,
            "y": 706.8333307902018
        },
        "closest": [
            13,
            6
        ]
    },
    {
        "id": 13,
        "position": {
            "x": 193.125,
            "y": 815.1666641235352
        },
        "closest": [
            14,
            12
        ]
    },
    {
        "id": 14,
        "position": {
            "x": 324.375,
            "y": 730.1666641235352
        },
        "closest": [
            15,
            13
        ]
    },
    {
        "id": 15,
        "position": {
            "x": 455,
            "y": 630.9999974568685
        },
        "closest": [
            29,
            24,
            14,
            16
        ]
    },
    {
        "id": 16,
        "position": {
            "x": 383.75,
            "y": 515.9999974568685
        },
        "closest": [
            15,
            11
        ]
    },
    {
        "id": 17,
        "position": {
            "x": 600,
            "y": 325.99999745686847
        },
        "closest": [
            23,
            9
        ]
    },
    {
        "id": 18,
        "position": {
            "x": 642.5,
            "y": 132.66666412353516
        },
        "closest": [
            19,
            9
        ]
    },
    {
        "id": 19,
        "position": {
            "x": 753.125,
            "y": 61.83333079020182
        },
        "closest": [
            20,
            18
        ]
    },
    {
        "id": 20,
        "position": {
            "x": 836.875,
            "y": 168.4999974568685
        },
        "closest": [
            21,
            19
        ]
    },
    {
        "id": 21,
        "position": {
            "x": 901.875,
            "y": 283.49999745686847
        },
        "closest": [
            22,
            20
        ]
    },
    {
        "id": 22,
        "position": {
            "x": 798.75,
            "y": 380.99999745686847
        },
        "closest": [
            23,
            21
        ]
    },
    {
        "id": 23,
        "position": {
            "x": 693.75,
            "y": 464.33333079020184
        },
        "closest": [
            25,
            24,
            17,
            22
        ]
    },
    {
        "id": 24,
        "position": {
            "x": 572.5,
            "y": 542.6666641235352
        },
        "closest": [
            15,
            23
        ]
    },
    {
        "id": 25,
        "position": {
            "x": 758.125,
            "y": 575.1666641235352
        },
        "closest": [
            26,
            23
        ]
    },
    {
        "id": 26,
        "position": {
            "x": 829.375,
            "y": 681.8333307902018
        },
        "closest": [
            30,
            27,
            25
        ]
    },
    {
        "id": 27,
        "position": {
            "x": 718.125,
            "y": 761.8333307902018
        },
        "closest": [
            26,
            28
        ]
    },
    {
        "id": 28,
        "position": {
            "x": 613.125,
            "y": 816.8333307902018
        },
        "closest": [
            27,
            29
        ]
    },
    {
        "id": 29,
        "position": {
            "x": 531.875,
            "y": 720.1666641235352
        },
        "closest": [
            28,
            15
        ]
    },
    {
        "id": 30,
        "position": {
            "x": 909.375,
            "y": 781.8333307902018
        },
        "closest": [
            26
        ]
    }
];